/** @jsx jsx */
import { jsx } from '@emotion/react';

import _t from 'i18n!nls/skills-common';

import ProgressTrackerPopoverContent from './ProgressTrackerPopoverContent';
import { generateBenchmarkCopyForSkillScoring } from './messages';

type BenchmarkScorePopoverContentProps = {
  score?: number;
  target?: number;
  skillName?: string;
};

const styles = {
  noScoreText: {
    fontSize: 12,
    color: 'var(--cds-color-grey-700)',
  },
};

const BenchmarkScorePopoverContent = (props: BenchmarkScorePopoverContentProps) => {
  const { score, skillName, target } = props;

  if (target === undefined) {
    return (
      <ProgressTrackerPopoverContent trackingData={{ skillName, score, target }} score={target} skillName={skillName}>
        <div css={styles.noScoreText}>{_t('There is no set target for this skill.')}</div>
      </ProgressTrackerPopoverContent>
    );
  }

  const benchmarkCopy = generateBenchmarkCopyForSkillScoring(target);

  return (
    <ProgressTrackerPopoverContent
      trackingData={{ skillName, score, target }}
      score={target}
      copy={benchmarkCopy}
      skillName={skillName}
    />
  );
};

export default BenchmarkScorePopoverContent;
